import { ITransition } from 'src/app/pages/home/components/transition/transition.interface';
import { ICaseStudies, InitiativeTab } from './../../interfaces/home.interface';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ClientDetails,
  Competency,
  DashboardDetails,
  InnovationAndProductivity,
} from '../../interfaces/home.interface';
import { HomeApiStateKeyNames, HomeApiStates } from '../../enums/home.enum';
import { HomeService } from '../../services/home/home.service';
import { PAGES } from '../../constants/route.constants';
import { ToasterService } from '../../components/toast/toaster.service';
import { Subject } from 'rxjs';
import { Meetings } from './components/meetings/meetings.interface';
import { initiativesTabs } from 'src/app/constants/endpoint.constants';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit, OnDestroy {
  public breadcrumbs = [{ label: 'HOME', url: `/${PAGES.HOME}` }];
  public innovationAndProductivity!: InnovationAndProductivity[];
  public clientDetails!: ClientDetails;  
  showChatbot: boolean = false;
  pastMeetings: Meetings[] = [];
  caseStudies: ICaseStudies[] = [];
  meetingLoading: boolean = false;
  caseStudiesLoading: boolean = false;  
  loading: boolean = false;
  innovationInflightLength: number = 0;
  innovationCompletedLength: number = 0;
  rating = 3;
  csTabs = [
    {
      id: 1,
      label: 'Customer Satisfaction',
      name: 'customerSatisfaction',
      active: true,
    },
    {
      id: 2,
      label: 'SLA Compliance',
      name: 'slaCompliance',
      active: false,
    },
  ];
  RevTabs = [
    {
      id: 1,
      label: 'GDS Integration',
      name: 'gdsIntegration',
      active: true,
    },
    {
      id: 2,
      label: 'Invoicing Status',
      name: 'invoiceStatus',
      active: false,
    },
    {
      id: 3,
      label: 'EY Revenue Potential',
      name: 'revenuePotential',
      active: false,
    },
  ];
  gdsIntegrationChartData: any = [];
  gdsIntegrationKeyData: any = ['gds', 'onshore'];
  currentCtActiveTab = 'customerSatisfaction';
  currentRevActiveTab = 'gdsIntegration';
  handleTabClick(tab: string, name: string) {
    if (name === 'rev') {
      this.currentRevActiveTab = tab;
    } else if (name === 'sla') {
      this.currentCtActiveTab = tab;
    }
  }
  public dashboardDetails: DashboardDetails = {};
  public apiStates: HomeApiStates = {
    [HomeApiStateKeyNames.DASHBOARD_DETAILS]: {
      inProgress: false,
      completed: false,
    },
  };
  private destroy$: Subject<void> = new Subject<void>();

  upcomingMeetings: any = [{ meetingDate: new Date().toISOString() }];
  initiativesTabs:InitiativeTab[] = initiativesTabs;
  initiativesData: InnovationAndProductivity[] = [];
  activeInitiativeType:InitiativeTab = {
    activeIcon: 'assets/images/inflights_active.svg',
    inActiveIcon: 'assets/images/inflights_inactive.svg',
    name: 'Inflight',
    count: 0,
    active: true,
  };
  quickLinks: Array<any> = [
    {
      img: 'assets/images/img1.png',
      text: 'Contractual Documents',
    },
    {
      img: 'assets/images/img2.png',
      text: 'Asset Library',
    },
  ];

  public width: number = 55;
  public height: number = 55;
  public persona: string = '';
  engagementId:any = "";

  slaInformation: any;
  constructor(
    private router: Router,
    private homeServiceRef: HomeService,
    private toasterServiceRef: ToasterService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.homeServiceRef.persona$.subscribe((persona) => {
      this.persona = persona;
    });
    this.engagementId = this.route.snapshot.paramMap.get('id');
    // this.getDashboardDetails();
    this.meetingLoading = true;
    if (this.engagementId) {
      this.homeServiceRef.setEngagementId(this.engagementId);
      this.homeServiceRef.getInnovationAndProductivity(this.engagementId).subscribe((res) => {
        this.innovationAndProductivity = res;
        this.initiativesData = res.filter(
          (r: InnovationAndProductivity) => r.status === 'Inflight'
        );
        this.innovationInflightLength = this.initiativesData.length;

        this.innovationCompletedLength = res.filter(
          (r: InnovationAndProductivity) => r.status === 'Completed'
        ).length;
        this.initiativesTabs.forEach((item) => {
          if (item.name === 'Inflight') {
            item.count = this.innovationInflightLength;
          }
          if (item.name === 'Completed') {
            item.count = this.innovationCompletedLength;
          }
        });
      });
      this.homeServiceRef.getClientDetails(this.engagementId).subscribe((res) => {
        if (!!res) {
          this.clientDetails = res[0];
          const satisfactionLevel = res[0].custSatisfactionLevelCurrent;
          switch (satisfactionLevel) {
            case 'Poor':
              this.rating = 1;
              break;
            case 'Average':
              this.rating = 2;
              break;
            case 'Good':
              this.rating = 3;
              break;
            case 'VeryGood':
              this.rating = 4;
              break;
            default:
              this.rating = 2;
          }
        }
      });
      this.homeServiceRef.getGovernanceMeetings(this.engagementId).subscribe((res) => {
        if (!!res) {
          this.pastMeetings = res;
          this.meetingLoading = false;
        }
      });

      this.homeServiceRef.getCaseStudies(this.engagementId).subscribe((res) => {
        if (!!res) {
          this.caseStudies = res;
          this.caseStudiesLoading = false;
        }
      });

      this.homeServiceRef.getGDSIntegrationDetails(this.engagementId).subscribe({
        next: (competency: Competency) => {
          if (competency) {
            this.gdsIntegrationChartData = Object.values(competency).flatMap((items) => 
              items
              .filter((item) => item.gds != null)
              .map(({name, gds, onshore}) => ({
                name,
                gds,
                onshore
              }))
            );
          }
        },
      });
    }
  }
  ngAfterViewInit(): void {
    // this.loading = false;
  }

  tabClickHandler(tab:InitiativeTab): void {
    this.activeInitiativeType = tab;
    tab.name === 'Inflight'
      ? (this.initiativesData = this.innovationAndProductivity.filter(
          (res) => res.status === 'Inflight'
        ))
      : (this.initiativesData = this.innovationAndProductivity.filter(
          (res) => res.status === 'Completed'
        ));
    this.initiativesTabs.forEach((item) => {
      item.active = item.name === tab.name;
    });
  }

  goto(linkName:any){
    if(this.engagementId != "")
    {
      if(linkName == "Governance Meetings"){
        this.router.navigate([`/governance-meetings`, {id:this.engagementId}]);
      }
      if(linkName == "Innovation Productivity"){
        this.router.navigate([`/innovation-productivity`, this.engagementId]);
      }
      if(linkName == "Transition Page"){
        this.router.navigate([`/transition-page`, {id:this.engagementId}]);
      }
    }
  
  }
  toggleChatbot(): void {
    this.showChatbot = !this.showChatbot;
  }
  ngOnDestroy(): void {
    this.homeServiceRef.setEngagementId('');
    this.destroy$.next();
    this.destroy$.complete();
  }

}
